import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateFeedbackRequest, FeedbackDto } from '../models/feedback.models';
import { BaseResponse } from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private readonly url = `${environment.apiUrl}/api/feedback`;
  private readonly adminUrl = `${environment.apiUrl}/api/admin/feedbacks`;

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(private http: HttpClient) {}

  submit(req: CreateFeedbackRequest): Observable<BaseResponse<{ id: string }>> {
    return this.http.post<BaseResponse<{ id: string }>>(this.url, req);
  }

  getAll(unreadOnly?: boolean): Observable<BaseResponse<FeedbackDto[]>> {
    let params = new HttpParams();
    if (unreadOnly != null) params = params.set('unreadOnly', unreadOnly);
    return this.http.get<BaseResponse<FeedbackDto[]>>(this.adminUrl, { params });
  }

  getUnreadCount(): Observable<BaseResponse<number>> {
    return this.http.get<BaseResponse<number>>(`${this.adminUrl}/unread-count`);
  }

  markRead(id: string): Observable<BaseResponse<void>> {
    return this.http.put<BaseResponse<void>>(`${this.adminUrl}/${id}/read`, {});
  }
}
